<!-- MFA signup view (QR + code) -->
<section class="form-group fadeInDown text-center" id="formContent" [ngClass]="{ 'd-none': loading }">
  <article [ngClass]="theme.getThemeClass()">
    <img class="logo" src="../assets/muirwood-studio.png" />
    <h2 class="text-center">{{ "signUpMFA" | translate }}</h2>

    <form
      (ngSubmit)="ctx.submitMFACodeClick()"
      id="register-form"
      role="form"
      autocomplete="off"
      class="form"
      method="post"
    >
      <!-- Section for the SMS sign-up display ------ NOT IN USE FOR NOW -->
      @if (ctx.mfaChecked) {
      <p>{{ "smsSendTo" | translate }}</p>
      <div class="input-group">
        <input
          type="text"
          id="phone_number"
          [(ngModel)]="ctx.phone_number"
          class="form-control"
          name="phone_number"
          placeholder="{{ 'phoneNumber' | translate }}"
          required
          minlength="1"
          [attr.readonly]="true"
          onfocus="this.blur()"
        />
      </div>
      <div class="input-group">
        <input
          type="text"
          id="codeMFA"
          [(ngModel)]="ctx.MFACodeSMS"
          class="form-control"
          name="codeMFA"
          placeholder="{{ 'enterMFACode' | translate }}"
          required
          minlength="1"
        />
      </div>
      <nav class="divBtn">
        <a class="btnA" (click)="ctx.cognitoService.sendSMS()">
          <div class="btn">
            <input
              class="inputBtn"
              name="recover-submit"
              value="{{ 'sendMFACode' | translate }}"
              type="submit"
            />
          </div>
        </a>
        <a class="btnA">
          <div class="btn">
            <input
              class="inputBtn"
              name="recover-submit"
              value="{{ 'loginForgotSubmit' | translate }}"
              type="submit"
            />
          </div>
        </a>
      </nav>
      }

      <!-- Section for the TOTP sign-up -->
      <!-- First page that display the QR code -->
      @if (!ctx.mfaChecked && view === ctx.LoginView.MfaSignUpQr) {
      <div [ngClass]="theme.getThemeClass()">
        @if (ctx.cognitoService.qrCodeImgActive) {
        <img [src]="ctx.cognitoService.imgUrl" alt="Code Qr" />
        }

        <nav class="divBtn">
          <a class="btnA" (click)="ctx.backToEditPage()">
            <div class="btn">
              <input
                class="inputBtn"
                name="recover-submit"
                value="{{ 'userEditButtonLabelReturn' | translate }}"
                type="submit"
              />
            </div>
          </a>
          <a class="btnA">
            <div class="btn">
              <input
                class="inputBtn"
                (click)="ctx.setView(ctx.LoginView.MfaSignUpCode)"
                name="recover-submit"
                value="{{ 'next' | translate }}"
                type="button"
              />
            </div>
          </a>
        </nav>
      </div>
      }

      <!-- Second page that ask to enter the verification TOTP code -->
      @if (!ctx.mfaChecked && view === ctx.LoginView.MfaSignUpCode) {
      <div [ngClass]="theme.getThemeClass()">
        <div [ngClass]="theme.getThemeClass()" class="input-group">
          <input
            type="text"
            id="codeMFA"
            [(ngModel)]="ctx.MFACodeTOTP"
            class="form-control"
            name="codeMFA"
            placeholder="{{ 'enterMFACode' | translate }}"
            required
            minlength="1"
          />
        </div>
        <nav [ngClass]="theme.getThemeClass()" class="divBtn">
          <a class="btnA">
            <div class="btn">
              <input
                class="inputBtn"
                (click)="ctx.setView(ctx.LoginView.MfaSignUpQr)"
                name="recover-submit"
                value="{{ 'back' | translate }}"
                type="button"
              />
            </div>
          </a>
          <a class="btnA">
            <div class="btn">
              <input
                class="inputBtn"
                name="recover-submit"
                value="{{ 'loginForgotSubmit' | translate }}"
                type="submit"
              />
            </div>
          </a>
        </nav>
      </div>
      }
    </form>
  </article>
</section>
